import { Pool } from "pg";
import { Id } from "./db.server";

export enum RequestType {
  UnexpectedActivity = 0,
  CreateUserDomain = 1,
  UserNeedsSpamHelp = 2,
  CelebrateGoodTimes = 3,
  UserFeedback = 4,
  HeadsUp = 5,
}

export enum RequestStatus {
  Todo = 0,
  Done = 1,
  NoActionTaken = 2,
  CausedByTesting_Ignored = 3,
}

export interface ActionRequestRow {
  id: Id;
  type: RequestType;
  status: RequestStatus;
  data: Record<string, unknown>;
  // received
  // processed
  message: string;
}

const mapActionRequestRowToActionRequest = (row: ActionRequestRow) => {
  return {
    ...row,
    // I thought this needed a JSON.parse, but the data returned
    // is already an Object
    data: row.data,
  };
};

export interface ActionRequest {
  id: Id;
  type: RequestType;
  status: RequestStatus;
  data: Record<string, unknown>;
  // received
  // processed
  message: string;
}

export const writeActionRequest = async (
  pool: Pool,
  type: RequestType,
  message: string,
  data: Record<string, unknown>,
) => {
  const res = await pool.query(
    `INSERT INTO action_requests 
  (type, data, status, received, message) 
  VALUES
  ($1, $2, $3, $4, $5);`,
    [type, data, RequestStatus.Todo, new Date(), message],
  );
};

export const getActiveActionRequests = async (pool: Pool): Promise<ActionRequest[]> => {
  const res = await pool.query(`SELECT * FROM action_requests WHERE status = 0;`);
  return res.rows.map(mapActionRequestRowToActionRequest);
};

export const updateActionRequest = async (pool: Pool, id: Id, newStatus: RequestStatus) => {
  await pool.query(`UPDATE action_requests SET status = $2 WHERE id=$1`, [id, newStatus]);
};
